import { message as toastNotification } from "antd";
import PropTypes from "prop-types";
import { useEffect } from "react";
import CircularProgress from "../CircularProgress";

const AppNotificationContainer = ({ loading, error, message }) => {
  useEffect(() => {
    const renderContent = (content) => {
      if (typeof content === "string" || typeof content === "number") {
        return content;
      }
      if (content && content.message) {
        return content.message;
      }
      return JSON.stringify(content);
    };

    error &&
      toastNotification.error(
        <span id="message-id">{renderContent(error)}</span>,
      );
    message &&
      toastNotification.success(
        <span id="message-id">{renderContent(message)}</span>,
      );
  }, [error, message]);
  return (
    <>
      {loading && (
        <div className="gx-loader-view gx-loader-position">
          <CircularProgress />
        </div>
      )}
    </>
  );
};

AppNotificationContainer.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  message: PropTypes.string,
};
export default AppNotificationContainer;
